import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    padding: '5px',
    color: 'white',
    width: '100%',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const EmployeeVisibilityDropdown = ({ getEmployeeVisibility, employee }) => {
    const options = [
        { value: 'Staff', label: 'Staff' },
        { value: 'Foreign Worker', label: ' Foreign Worker' },
        { value: 'Local Worker', label: 'Local Worker' },
        { value: 'Trainee', label: 'Trainee' },
    ];

    const [selectedOption, setSelectedOption] = useState('');

    useEffect(() => {
        if(employee) {
            const insertEmployee = () => {
                if (employee.indexOf(',') > -1) {
                    let array = employee.split(',')
                    let newArray = array.map(item => ({ value: item, label: item }))
                    setSelectedOption(newArray)
                } else {
                    let string = { value: employee, label: employee }
                    setSelectedOption(string)
                }
            }
            
        insertEmployee()
        }
    }, [employee])

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        getEmployeeVisibility(
            Array.isArray(selectedOption)
            ? selectedOption.map((item) => item.value)
            : null
        );
    };

    return (
        <Select
            closeMenuOnSelect={false}
            placeholder={'Select an employee type...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isMulti
        />
    );
};

export default EmployeeVisibilityDropdown;
